export default "__VITE_ASSET__LJoguIhi__"